import { getFromHub } from "../actions/networkActions";


export function getAdyenLocale(lang = "en") {
    switch (lang?.toLowerCase()) {
        case "fr":
            return "fr-FR";
        case "en":
        default:
            return "en-US";
    }
}


export async function pollPaymentWebhookStatus({
    transactionId,
    intervalMs = 1000,
    timeoutSeconds = 15,
    passengerId,
    signal, // aborted when the guest leaves the page; no further requests are made
} = {}) {
    const maxAttempts = Math.ceil((timeoutSeconds * 1000) / intervalMs);
    let attempts = 0;
    let failedRequests = 0; // requests that got no answer or a 5xx; they are retried, and the count tells a hub outage apart from a slow webhook

    while (attempts < maxAttempts) {
        if (signal?.aborted) {
            return {
                aborted: true,
                isAuthorised: false,
            };
        }

        attempts += 1;

        let statusResponse = null;

        if (transactionId && passengerId) {
            const params = new URLSearchParams({ passengerId, transactionId });
            // getFromHub doesn't throw: a failed request comes back as { error }
            statusResponse = await getFromHub(`adyen/tokenization-status?${params.toString()}`);
        }

        if (statusResponse?.error) {
            const httpStatus = statusResponse.error.response?.status;

            // exit early on any 4xx response
            if (httpStatus >= 400 && httpStatus < 500) {
                return {
                    isAuthorised: false,
                };
            }

            failedRequests += 1;
        } else {
            const { status, reason } = statusResponse || {};

            if (status === "IN_PROGRESS") {
                // fall through to delay + next attempt - keep polling
            } else if (status === "SUCCESS") {
                return {
                    isAuthorised: true,
                };
            } else if (status === "FAILURE") {
                const isExpired =
                    typeof reason === "string" && reason.toUpperCase() === "CARD_EXPIRES_BEFORE_CRUISE_END"; // Check if this is valid while testing

                if (isExpired) {
                    return {
                        isExpired: true,
                        isAuthorised: false,
                    };
                }

                return {
                    isAuthorised: false,
                };
            } else {
                return {
                    isAuthorised: false,
                };
            }
        }

        if (attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, intervalMs));
        }
    }

    return {
        timedOut: true,
        isAuthorised: false,
        failedRequests,
    };
}
